import React from 'react'

import netlify from '../assets/netlify.png'
import gatsby from '../assets/gatsby.png'
import floppy from '../assets/floppylogo.png'

const links = [
  { url: 'https://github.com/taniarascia/taniarascia.com', label: 'Tania Rascia' },
  { url: 'https://tegarsantosa.com', label: 'Tegar Santosa' },
]
const madeWithLinks = [
  { url: 'https://www.gatsbyjs.org', label: 'Gatsby', icon: gatsby },
  { url: 'https://www.netlify.com', label: 'Netlify', icon: netlify },
]

export const Footer = () => {
  return (
    <footer className="footer">
      <section>
        <span>
          <img src={floppy} className="logo" alt="Tania Rascia" />
        </span>
        <nav>
          {links.map((link) => (
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              key={link.url}
            >
              {link.label}
            </a>
          ))}
        </nav>
        <nav>
          {madeWithLinks.map((link) => (
            <a
              href={link.url}
              title={link.label}
              target="_blank"
              rel="noopener noreferrer"
              key={link.url}
            >
              <span>{link.label}</span>
              <img src={link.icon} alt={link.label} />
            </a>
          ))}
        </nav>
      </section>
    </footer>
  )
}
